import { render, staticRenderFns } from "./FAvatar.vue?vue&type=template&id=4d7669b2&scoped=true&"
import script from "./FAvatar.vue?vue&type=script&lang=js&"
export * from "./FAvatar.vue?vue&type=script&lang=js&"
import style0 from "./FAvatar.vue?vue&type=style&index=0&id=4d7669b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7669b2",
  null
  
)

export default component.exports